import { useCurrentCustomerQuery } from 'queries/types/CurrentCustomerQuery'
import { useEffect } from 'react'
import { setReportingUser } from 'utils/sentry'

import { chatLogin, chatLogout } from 'utils/chatBox'
import { applyAccountOptOut } from 'utils/privacyPreferences'
import { applyConsent } from 'utils/analytics'
import { User } from 'queries/userTypes'

export type { User } from 'queries/userTypes'

type Result = {
  loading: boolean
  user: User | null
  refetch: () => void
}

type Args = {
  skip?: boolean
}

export default function useUser(
  { skip = false }: Args = { skip: false }
): Result {
  const { loading, data, refetch } = useCurrentCustomerQuery({
    fetchPolicy: 'cache-first',
    skip
  })
  const user = data?.currentCustomer || null

  useEffect(() => {
    // Must run first: setReportingUser and applyConsent both read the resolved state.
    applyAccountOptOut(user?.trackingOptedOut)
    applyConsent()

    setReportingUser(user)

    if (user) {
      chatLogin({ user })
    } else {
      chatLogout()
    }
  }, [user])

  return {
    loading,
    user,
    refetch
  }
}
